import React from "react";
import MapSection from "../components/map";
import dataMap from "../assets/fakeData/dataMap";
import Footer from "../components/footer";
import Gotop from "../components/gotop";
import Contact from "../components/contact";
import { useState } from "react";
import MobileHeader from "../components/header/MobileHeader";
import NonLoginHeader from "../components/header/NonLoginHeader";

function ContactUs(props) {
  const [isShowMobile, setShowMobile] = useState(false);
  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  return (
    <>
      <MobileHeader handleMobile={handleMobile} />
      <NonLoginHeader clname="" handleMobile={handleMobile} />

      <div className="pt-70">
        <MapSection markers={dataMap} />
        <Contact />
        <Footer />
        <Gotop />
      </div>
    </>
  );
}

export default ContactUs;
